'use client';

import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconEdit, IconPlus } from '@tabler/icons-react';
import { useSession } from 'next-auth/react';
import Link from 'next/link';

interface Props {
  climb: Climb;
}

export default function ClimbActions({ climb }: Props) {
  const { data: session } = useSession();

  // TODO: check if user has done the climb
  return (
    <Group gap='xs'>
      {session && session.user.role === 'admin' && (
        <Tooltip label='Edit Climb'>
          <ActionIcon component={Link} href={`/climbs/${climb.nameSlug}/edit`}>
            <IconEdit stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      )}
      {session && (
        <Tooltip label='Add Climb'>
          <ActionIcon
            component={Link}
            href={`/ascents/add?climb=${climb.nameSlug}`}
          >
            <IconPlus stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      )}
    </Group>
  );
}
